import type { TFunction } from "i18next";
import { NonAwardReason } from "../../../autogen/bff-api";

export const nonAwardReasons = (t: TFunction): [NonAwardReason, string][] => [
  [NonAwardReason.NoTendersReceived, t("No tenders received")],
  [NonAwardReason.AllRejected, t("All tenders rejected")],
  [NonAwardReason.OneAdmissible, t("Only one admissible tender")],
  [NonAwardReason.ChangedNeed, t("Changed need")],
  [NonAwardReason.InsufficientFunds, t("Insufficient funding")],
  [NonAwardReason.NoContractSigned, t("No contract signed")],
  [NonAwardReason.ReviewBodyDecision, t("Decision by a review body")],
  [NonAwardReason.BuyerReview, t("Renewed assessment by the buyer")],
  [
    NonAwardReason.TechnicalOrProceduralError,
    t("Technical or procedural error"),
  ],
  [NonAwardReason.Other, t("Other")],
];
